module.exports = __webpack_public_path__ + "static/media/join_btn_customer.c0dac9af.png";